<div class="wrap">
  <app-language-selector></app-language-selector>
  <div class="list">
    <app-list-item-button
      [isButton]="true"
      [header]="'@components.settings.about.header' | translate"
      [text]="'@components.settings.about.text' | translate"
      (click)="onOpenAboutScreen()"
    ></app-list-item-button>
    <app-list-item-button
      [isButton]="true"
      [header]="'@components.settings.deleteProfile.header' | translate"
      [color]="'color-state-error'"
      (click)="onDeleteProfileClick()"
    ></app-list-item-button>
  </div>
</div>
